module.exports = __webpack_public_path__ + "assets/90b1a2cb8ca22fa8c19db7325c18a85a.png";